module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Black-Italic.84021de9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Black-Italic.woff2
// module id = 2328
// module chunks = 50